import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { COLORS } from "../../constants/colors.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getCargoDataDuration,
  setCargoDataDuration,
} from "../../model/slice/dataDurationSlice.js";
import dayjs from 'util/dayjs-init.js';
import { CSVDownloadForCargoPage } from "../cargo/csvDownload/csvDownload.jsx";
import { calDurations } from "../../constants/calDuration.js";
import { useOnClickOutside } from "../../hooks/useOnClickOutside.js";
import { CARGO_PAGES } from "../../constants/cargo/pages.js";
import { Box } from "@mui/system";
import { MUIDateTimePicker } from "../dateTimePicker/dateTimePicker.jsx";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../i18n/localizationKeys.js";

const styles = {
  AdditionalContainer: {
    position: "fixed",
    top: "120px",
    right: "20px",
    width: "300px",
    height: "200px",
    background: COLORS.tabSelectorColor,
    zIndex: 110,
    outline: `solid 1px ${COLORS.white}`,
    borderRadius: "5px",
    padding: "20px 20px",
  },
  durationPickerContainer: {
    margin: "10px 5px",
  },
  downloadContainer: {
    margin: "10px 5px",
  },
};

export const AdditionalContainer = (props) => {
  const { vesselId, setOpen, selectedTab, selectedChart } = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const cargoDuration = useSelector(getCargoDataDuration);
  const containerRef = useRef(null);
  const [startDate, setStartDate] = useState(
    cargoDuration.startDate === ""
      ? dayjs.utc().subtract(1, "M").toDate()
      : cargoDuration.startDate
  );
  const [endDate, setEndDate] = useState(
    cargoDuration.endDate === "" ? dayjs.utc().toDate() : cargoDuration.endDate
  );
  // close this container when click outside and not open duration picker
  useOnClickOutside([containerRef], () => {
    const popover = document.getElementsByClassName('MuiDialog-paper');
    if(!popover[0]) setOpen(false)
  });

  useEffect(() => {
    let updateStartDate, updateEndDate;
    if (startDate === "" && endDate === "") {
      return;
    } else if (endDate === "") {
      updateStartDate = dayjs.utc(startDate).format();
      updateEndDate = dayjs.utc(startDate).endOf("d").format();
    } else if (startDate === "") {
      updateStartDate = dayjs.utc(endDate).format();
      updateEndDate = dayjs.utc(endDate).endOf("d").format();
    } else {
      updateStartDate = dayjs.utc(startDate).format();
      updateEndDate = dayjs.utc(endDate).format();
    }
    const interval = calDurations({startDate, endDate});
    dispatch(setCargoDataDuration({startDate: updateStartDate, endDate: updateEndDate, interval}));
  }, [startDate, endDate]);

  return (
    <Grid sx={styles.AdditionalContainer} ref={containerRef}>
      <Box sx={styles.durationPickerContainer}>
        <span style={{ color: "white" }}>Select a Duration</span>
        <Box sx={{width: '100%'}}>
          <Typography color="white" fontSize={12}>{t(localizationKeys.StartTime)}</Typography>
          <MUIDateTimePicker isSEPVessel={false} date={startDate} setDateFunction={(d) => setStartDate(d)} isStart={true} limitationDate={endDate}/>
          <Typography color="white" fontSize={12}>{t(localizationKeys.EndTime)}</Typography>
          <MUIDateTimePicker isSEPVessel={false} date={endDate} setDateFunction={(d) => setEndDate(d)} isStart={false} limitationDate={startDate}/>
        </Box>
      </Box>
      <CSVDownloadForCargoPage
        vesselId={vesselId}
        startDate={startDate}
        endDate={endDate}
        fileType={selectedTab === CARGO_PAGES.TRANSPORT 
          ? CARGO_PAGES.TRANSPORT 
          : selectedChart}
      />
    </Grid>
  );
};

AdditionalContainer.propTypes = {
  vesselId: PropTypes.string,
  setOpen: PropTypes.func,
  selectedTab: PropTypes.string,
  selectedChart: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(null)])
};
